import { Component, OnInit } from "@angular/core";
import { MyAccountService } from "../my-account.service";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
@Component({
  selector: "app-change-password",
  templateUrl: "./change-password.component.html",
  styleUrls: ["./change-password.component.css"],
})
export class ChangePasswordComponent implements OnInit {
  model: any = {};
  isActive: boolean;
  isLoading = false;
  oldPasswordType: any = "password";
  newPasswordType: any = "password";
  confirmPasswordType: any = "password";
  constructor(
    public changeService: MyAccountService,
    private toastr: ToastrService,
    private route: Router
  ) {}

  ngOnInit(): void {
    this.isActive = true;
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }
  /**
   * This function is use for reset password
   * @param form
   */
  resetPassword(form) {
    this.isLoading = true;
    if (
      this.model.new_password != this.model.confirm_password ||
      this.model.new_password === this.model.old_password
    ) {
      this.isLoading = false;
      form = false;
    }
    if (form) {
      this.changeService.changePassword(this.model).subscribe(
        (res) => {
          if (res) {
            this.isLoading = false;
            this.toastr.success("Password changed successfully!", "Success!", {
              closeButton: true,
            });
            this.model = {};
            form.resetForm();
            this.route.navigate(["/my-account/profile"]);
          }
        },
        (err) => {
          if (err) {
            this.isLoading = false;
            this.toastr.error("current password does not match!", "OOPS!", {
              closeButton: true,
            });
          }

        }
      );
    }
  }
  /**
   * This function is use for change password
   * @param type
   */
  changePasswordType(type: any): void {
    if (type === "oldPassword") {
      if (this.oldPasswordType === "password") {
        this.oldPasswordType = "text";
      } else {
        this.oldPasswordType = "password";
      }
    } else if (type === "newPassword") {
      if (this.newPasswordType === "password") {
        this.newPasswordType = "text";
      } else {
        this.newPasswordType = "password";
      }
    } else if (type === "confirmPassword") {
      if (this.confirmPasswordType === "password") {
        this.confirmPasswordType = "text";
      } else {
        this.confirmPasswordType = "password";
      }
    }
  }
  /**
   * This function is use for remove active class
   */
  remove() {
    this.isActive = false;
    this.changeService.isActive = false;
  }
}
